import { Button } from "@/components/ui/button";
import { Apple, Smartphone } from "lucide-react";

interface AppDownloadButtonsProps {
  className?: string;
  variant?: "default" | "compact";
}

export function AppDownloadButtons({ className = "", variant = "default" }: AppDownloadButtonsProps) {
  const handleAppStoreClick = () => {
    // Placeholder - will be updated when app launches
    console.log("App Store link - Coming Soon");
  };

  const handlePlayStoreClick = () => {
    // Placeholder - will be updated when app launches
    console.log("Google Play link - Coming Soon");
  };

  if (variant === "compact") {
    return (
      <div className={`flex gap-3 ${className}`}>
        <Button
          variant="outline"
          size="sm"
          onClick={handleAppStoreClick}
          className="bg-card hover:bg-muted transition-smooth"
        >
          <Apple className="h-4 w-4 mr-2" />
          App Store
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={handlePlayStoreClick}
          className="bg-card hover:bg-muted transition-smooth"
        >
          <Smartphone className="h-4 w-4 mr-2" />
          Google Play
        </Button>
      </div>
    );
  }

  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <button
        onClick={handleAppStoreClick}
        className="group flex items-center gap-3 px-6 py-3 bg-card border-2 border-border rounded-xl hover:border-primary hover:shadow-glow transition-smooth"
        aria-label="Download on the App Store"
      >
        <Apple className="h-8 w-8" />
        <div className="text-left">
          <div className="text-xs text-muted-foreground">Download on the</div>
          <div className="text-base font-semibold">App Store</div>
        </div>
      </button>

      <button
        onClick={handlePlayStoreClick}
        className="group flex items-center gap-3 px-6 py-3 bg-card border-2 border-border rounded-xl hover:border-primary hover:shadow-glow transition-smooth"
        aria-label="Get it on Google Play"
      >
        <Smartphone className="h-8 w-8" />
        <div className="text-left">
          <div className="text-xs text-muted-foreground">Get it on</div>
          <div className="text-base font-semibold">Google Play</div>
        </div>
      </button>
    </div>
  );
}
